import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Lookup
} from 'devextreme-react/data-grid';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { backendlink } from '../../config';
import './PartnerDoctorListDatagrid.css';

export default function PartnerDoctorListDatagrid() {

    const { user } = useAuth();

    const navigate = useNavigate();

    const [users, setUsers] = useState([]);

    const [formData, setformData] = useState({ startDate: '', endDate: '' });

    function handleRowClick(e) {
        const doctorToken = e.data.userToken;
        navigate('/partner-doctor-info', { state: { doctorToken: doctorToken } });
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(backendlink + 'partner/getalldoctors',
                {
                    usertoken: user.userToken
                },
                {
                    headers: {
                        token: user.token
                    }
                });
                if (response.data.errorno === 0) {
                    const outputArray = response.data.result[0].map(item => {
                        var statusString = (item.isEnabled === true ? 'Active' : 'Inactive')

                        return { doctorID: item.id, doctorName: item.name, description: item.description0, status: statusString, phone: item.phone, email: item.email, linkedCustomer: item.linkedcustomer, userToken: item.userToken };
                    });
                    setUsers(outputArray)
                }
                else if (response.data.errorno === 330) {
                    setUsers([])
                }
                else {
                    alert(response.data.errmessage);
                }
            } catch (error) {
                alert(error);
            }
        };

        fetchData();

        var dateStartdate = new Date(Date.now() - 86400000)
        var dateEnddate = new Date()

        setformData({ startDate: dateStartdate, endDate: dateEnddate })
    }, [user]);

  return (
    <React.Fragment>
        <DataGrid dataSource={users} onRowClick={handleRowClick}>
            <Column dataField='doctorID' caption='Doctor Account ID'  alignment='left' />
            <Column dataField="doctorName"  caption='Doctor Name' />
            <Column dataField='description'  caption='Description' />
            <Column dataField='phone'  caption='Phone Number' />
            <Column dataField="email" caption='Contact Email' />
            <Column dataField="linkedCustomer" caption='Linked Organization' />
            <Pager allowedPageSizes={[5, 10, 20]} showPageSizeSelector={true} />
            <Paging defaultPageSize={5} />
            <FilterRow visible={true} />
            <Lookup />
        </DataGrid>
    </React.Fragment>
  )

}
